<template>
  <div class="page-header">
    <!-- <v-btn
      v-if="isShowBackBtn"
      icon
      depressed
      dark
      class="btn-back"
      @click="$emit('clickBack')"
    >
      <v-icon dark>mdi-arrow-left</v-icon>
    </v-btn> -->
    <v-btn
      v-if="isShowBackBtn"
      icon
      depressed
      dark
      class="btn-close"
      @click="$emit('clickBack')"
    >
      <v-icon dark>mdi-close</v-icon>
    </v-btn>
    <div class="header-logo"><img src="@/assets/images/common/bayer_logo_white.png" alt=""></div>
    <h3 class="page-title">{{ headTitle }}</h3>
    <div class="loginOut" v-if="isShowLoginBtn">
      <span v-if="isAuthorized">
        <span @click="$emit('clickUserInfo')"><v-icon>mdi-menu</v-icon></span>
      </span>
      <p v-else @click="$emit('clickLogIn')">로그인</p>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    isShowBackBtn: {
      type: Boolean,
      default: false,
    },
    headTitle: {
      type: String,
      default: "",
    },
    isShowLoginBtn: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(["isAuthorized"]),
  },
  methods: {},
};
</script>

<style lang="scss">
.page-header {
  position: relative;
  margin-bottom: 1rem;
  padding: 1rem;
  text-align: center;
  background: $mid-green;
  color: #ffffff;
  border-radius: 0 0 20px 20px;
  .header-logo {
    position: absolute;
    left: 15px;
    top: 12px;
    img {
      height: 36px;
    }
  }
  .btn-back {
    position: absolute;
    left: 15px;
    top: 12px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
  }
  .btn-close {
    position: absolute;
    right: 15px;
    top: 12px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
  }
  .page-title {
    color: #ffffff;
    font-size: 1.3rem;
    margin-bottom: 0;
  }
  .v-icon {
    color: #ffffff;
  }
}
.loginOut {
  position: absolute;
  top: 1.2rem;
  right: 1.2rem;
}
</style>